import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useFetchOpportunity } from "~/api/salesForce/useFetchOpportunity";
import { useFetchProductDetails } from "~/api/storyblok/useFetchProductDetails";
import OfferCard from "~/components/molecules/OfferCard/OfferCard";
import { Product } from "~/stores/checkout/product";

type CosmeticCardProps = {
  product?: Product;
};

const CosmeticCard = ({ product }: CosmeticCardProps) => {
  const { opportunityId } = useParams();
  const { data: opportunity, isLoading: loadingOpportunity } =
    useFetchOpportunity({
      id: opportunityId as string,
    });
  const intl = useIntl();
  const { data } = useFetchProductDetails(product?.productCardKey);

  return (
    <AnimatePresence>
      {!loadingOpportunity && product && (
        <OfferCard
          benefits={data?.hideBenefits ? [] : data?.benefits}
          title={product.name}
          price={intl.formatMessage(
            { id: "pricing.amount" },
            { amount: product.price }
          )}
          image={{
            male: data?.image?.male,
            female: data?.image?.female,
          }}
          opportunityGender={opportunity?.gender}
        >
          {/* <EditableSkinBundle editable={opportunity?.isValidForSales} /> */}
          {/* <Subtitle className="text-grey-400" level={3}>
            {bundle.bundleProducts.map((product) => product.name).join(", ")}
          </Subtitle> */}
        </OfferCard>
      )}
    </AnimatePresence>
  );
};

export default CosmeticCard;
